import stompManager from './stompManager';
import topicMessageManager from './topicMessageManager';
import { isJsonString } from '../typeCheckUtils';

const subscribeTopic = (topicPath, handler) => {
  const client = stompManager.getStompClient();
  if (!client || !client.connected) {
    return null;
  }

  if (handler) {
    topicMessageManager.registerTopicHandler(topicPath, handler);
  }

  return client.subscribe(topicPath, (message) => {
    try {
      const payload = isJsonString(message.body)? JSON.parse(message.body) : message.body;
      topicMessageManager.dispatchTopicMessage(topicPath, payload);
      console.log('STOMP subscribeTopic success', payload);
    } catch (error) {
      console.error('STOMP subscribeTopic 토픽 메시지 파싱 오류:', error);
      topicMessageManager.dispatchTopicMessage(topicPath, message.body);
    }
  });
};

//unsubscribeTopic의 param : client.subscribe(topicPath, handler); (subscribeTopic의 응답값)
const unsubscribeTopic = (subscription, topicPath) => {
  if(subscription) {
    subscription.unsubscribe();
  }
  if (topicPath) {
    topicMessageManager.unregisterTopicHandler(topicPath);
  }
};

const topicManager = {
  subscribeTopic,
  unsubscribeTopic,
};

export default topicManager;